module.exports = __webpack_public_path__ + "media/images/badge-12px-06625330d4056285f079597b48a52a80.svg";